import type { ProductProps } from 'tsconfig/types';
import { CartButton } from '../../../AddToCart/Button';
interface Props {
  cartItems: any;
  hit?: ProductProps | ProductProps[];
}

export const AddToCartSection = ({ cartItems, hit }: Props) => (
  <div className="mcs-main-row">
    <CartButton
      itemCode={cartItems.cartItems?.[0]?.itemCode ?? ''}
      buttonText="ADD TO CART"
      cartItems={cartItems}
      method={cartItems.cartItems?.length > 1 ? 'batch' : undefined}
      qty={'1'}
      fontWeight="600"
      hit={hit}
    />
  </div>
);
